import { forwardRef, type Ref, type SVGProps } from "react";
const IconFilePDFFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M25 28H7v-2H5v2a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-2h-2zm1.42-19.57-5.83-5.84A2 2 0 0 0 19.18 2H7a2 2 0 0 0-2 2v9h2V4h11v5a2 2 0 0 0 2 2h5v2h2V9.84a2 2 0 0 0-.58-1.41M16 17.86h-.6v3.28h.6c.75 0 1.29-.31 1.29-1.63-.01-.94-.29-1.65-1.29-1.65m-5.74-.03h-.67v1.71h.52c.62 0 1-.23 1-.86a.78.78 0 0 0-.85-.85"
    />
    <path
      fill="currentColor"
      d="M28 13H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2m-17.46 7.52h-.95v1.65H8.31v-5.34h2.25a1.76 1.76 0 0 1 1.87 1.85 1.75 1.75 0 0 1-1.89 1.84m5.66 1.65h-2.1v-5.34h2.1c1.66 0 2.41 1 2.41 2.65s-.77 2.69-2.41 2.69m7.73-4.3h-2.26v1.28h2.06v1h-2.06v2h-1.29v-5.32h3.55z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFilePDFFilledSVG);
ForwardRef.displayName = "IconFilePDFFilled";
export { ForwardRef as IconFilePDFFilled };
